import React from 'react';
import { string, node } from 'prop-types';

import VideoBlock from './components/VideoBlock';

import ContentBlock from '../ContentBlock';

function VideoPostContent({
  title,
  mediaEmbedUrl,
  mediaImageUrl,
  authorName,
  publishDate,
  description,
  breadcrumb,
}) {
  return (
    <article>
      <VideoBlock mediaEmbedUrl={mediaEmbedUrl} mediaImageUrl={mediaImageUrl} />
      <ContentBlock
        authorName={authorName}
        description={description}
        publishDate={publishDate}
        title={title}
        breadcrumb={breadcrumb}
        showAuthorBlock
      />
    </article>
  );
}

VideoPostContent.propTypes = {
  authorName: string.isRequired,
  breadcrumb: node.isRequired,
  description: string.isRequired,
  mediaEmbedUrl: string.isRequired,
  mediaImageUrl: string.isRequired,
  publishDate: string.isRequired,
  title: string.isRequired,
  type: string.isRequired,
};

export default VideoPostContent;



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/components/VideoPostContent/VideoPostContent.jsx